var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#8F92A1",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3596 8.94005C17.9396 9.12005 17.4596 9.24005 16.9796 9.30005C17.4596 9.00005 17.8796 8.52005 18.0596 7.98005C17.5796 8.28005 17.0996 8.46005 16.4996 8.58005C16.0796 8.10005 15.4196 7.80005 14.7596 7.80005C13.4396 7.80005 12.3596 8.88005 12.3596 10.2C12.3596 10.38 12.3596 10.56 12.4196 10.74C10.4396 10.62 8.63961 9.66005 7.43961 8.22005C7.25961 8.58005 7.13961 9.00005 7.13961 9.42005C7.13961 10.26 7.55961 10.98 8.21961 11.4C7.79961 11.4 7.43961 11.28 7.13961 11.1C7.13961 12.24 7.9796 13.26 9.0596 13.44C8.8796 13.5 8.63961 13.5 8.39961 13.5C8.21961 13.5 8.09961 13.5 7.91961 13.44C8.21961 14.4 9.11961 15.12 10.1996 15.12C9.35961 15.78 8.33961 16.14 7.19961 16.14C7.01961 16.14 6.83961 16.1401 6.59961 16.0801C7.67961 16.7401 8.93961 17.1601 10.3196 17.1601C14.7596 17.1601 17.1596 13.5 17.1596 10.32V10.02C17.6396 9.84005 18.0596 9.42005 18.3596 8.94005Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitterLogo.a8851924ae8eed810e3a28222332299f.svg";
export { ForwardRef as ReactComponent };